import React, { useState, useEffect } from "react";
import { optionsBranch } from "../data/branch-data";
import { internType } from "../data/interntype-data";
import { thaiMonth } from "../data/month-thai";
import {
  convertDateThai,
  converToThaiNumber,
  matchOptions,
  changePrefixName,
} from "../utils/function";

import { useSelector } from "react-redux";
import {
  getCompany,
  getInternshipRequest,
  getInternStudent,
} from "../api/crud";

const FormReview = ({ companyId, readOnly, removeStudent }) => {
  const profile = useSelector((state) => state.profileReducer.profile);
  const [companyDetail, setCompanyDetail] = useState(null);

  const getData = async (cp_id) => {
    const internStudent = await getInternStudent();
    const allCompany = await getCompany();
    const internshipRequest = await getInternshipRequest();
    console.log("internshipRequest", internshipRequest);

    const filterStudent = internStudent.filter((st) => st.status_id == 12);

    const studentDetail = filterStudent.map((st) => {
      const find = internshipRequest.find((el) => el.st_id == st.id);

      console.log("find", find);

      return {
        ...st,
        internDetail: find,
      };
    });

    const companyWithStd = allCompany
      .map((company) => {
        const internSt = studentDetail.filter((st) => {
          return (
            st.internDetail?.cp_id == company.id &&
            removeStudent.indexOf(st.id) === -1
          );
        });

        return {
          ...company,
          internStudent: internSt,
        };
      })
      .filter((item) => item.internStudent.length);

    const cpSelected = companyWithStd.find((el) => el.id === cp_id);

    setCompanyDetail(cpSelected);
  };

  useEffect(() => {
    if (companyId) {
      getData(companyId);
    }
  }, [companyId]);

  return (
    <form action="./add-document-internship.php" method="post">
      <div className="page-container">
        <div className="text-end my-2 px-2" id="section-to-not-print">
          {!readOnly && (
            <button type="submit" className="btn btn-primary mx-2">
              ยืนยัน
            </button>
          )}
        </div>
        <div className="page" id="section-to-print" style={{ color: "black",
        backgroundColor: "white",
         }}>
          <div className="">
            <div className="row">
              <div className="col-12 text-center" style={{ height: "22mm" }}>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/buu-logo-2.png`}
                  alt="buu logo"
                  width="100px"
                />
              </div>
              <div className="col-7 mb-3">
                <div>
                  ที่ อว ๘๑๑๖/
                  <input
                    style={{ width: "50px" }}
                    type="text"
                    className="input-form border-0 text-start"
                    name="idm_docnum"
                  />
                </div>
              </div>
              <div className="col-5 mb-3 d-flex justify-content-end">
                <div>
                  <div>คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา</div>
                  <div>ตำบลแสนสุข อำเภอเมืองฯ</div>
                  <div>จังหวัดชลบุรี ๒๐๑๓๑</div>
                </div>
              </div>
              <div className="col-6 mb-4"></div>
              <div className="col-6 ps-0 mb-4">
                <div>
                  <input
                    style={{ width: "150px" }}
                    type="text"
                    className="input-form border-0 text-start"
                    name="idm_docdate"
                    value={`  ${
                      thaiMonth[new Date().getMonth()]
                    }  ${converToThaiNumber(new Date().getFullYear() + 543)}`}
                  />
                </div>
              </div>
              <div className="col-12 mb-4">
                <div>
                  เรื่อง <span style={{ marginRight: "5mm" }} />
                  ขอความอนุเคราะห์รับนิสิตฝึกงานและปฎิบัติสหกิจศึกษา
                </div>
              </div>
              <div className="col-12">
                <div>
                  <span className="me-2">เรียน</span>
                  <span style={{ marginRight: "3mm" }} />
                  <input
                    style={{ width: "80%" }}
                    type="text"
                    name="idm_header"
                    className=" border-0"
                    value={`${companyDetail?.internStudent
                      .map((el) => {
                        return `${changePrefixName(
                          el?.internDetail?.co_name,
                          "คุณ"
                        )} ${el?.internDetail?.comment}`;
                      })
                      .join(" / ")} `}
                    // value={`${changePrefixName(
                    //   companyDetail?.internStudent[0]?.internDetail?.co_name,
                    //   "คุณ"
                    // )} `}
                  />
                </div>
              </div>
              <div className="col-12 mb-4" style={{ textIndent: "53px" }}>
                <div>{converToThaiNumber(companyDetail?.name)}</div>
              </div>
              <div className="col-12 mb-4">
                สิ่งที่ส่งมาด้วย
                แบบฟอร์มตอบรับนิสิตเข้ารับการฝึกงานและปฎิบัติสหกิจศึกษา
                จำนวน ๑ ชุด
              </div>

              <div className="col-12 mb-2" style={{ textIndent: "75px" }}>
                ตามที่คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา
                ได้เปิดสอนหลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมเคมี
                วิศวกรรมเครื่องกล วิศวกรรมไฟฟ้า วิศวกรรมโยธา วิศวกรรมอุตสาหการ
                วิศวกรรมสิ่งแวดล้อม วิศวกรรมระบบสมองกลฝังตัว และวิศวกรรมวัสดุ
                โดยกำหนดให้นิสิตชั้นปีที่ ๓ ขึ้นไป เข้ารับการฝึกประสบการณ์
                <br />
                เกี่ยวกับวิชาชีพในแต่ละสาขาวิชา ในหน่วยงาน{" "}
                <span className="text-nowrap">ภาครัฐ</span> ภาคเอกชน
                และโรงงานอุตสาหกรรมต่าง ๆ
                เพื่อให้นิสิตได้เรียนรู้และหาประสบการณ์ตรงในวิชาชีพตามหลักสูตร
                ในช่วงระยะเวลาที่กำหนดทุกภาคการศึกษา
              </div>
              <div className="col-12 mb-2" style={{ textIndent: "75px" }}>
                เพื่อให้การฝึกงานและปฎิบัติสหกิจศึกษา
                ในปีการศึกษานี้เป็นไปด้วยความเรียบร้อย
                <br />
                คณะวิศวกรรมศาสตร์ <span className="me-3" /> มหาวิทยาลัยบูรพา{" "}
                <span className="me-2" />
                จึงขอความอนุเคราะห์หน่วยงานของท่านรับนิสิตเข้า
                <span className="">
                  {converToThaiNumber(
                    matchOptions(
                      internType,
                      companyDetail?.internStudent[0]?.internDetail
                        ?.type_internship
                    )
                  )}
                </span>{" "}
                ตั้งแต่
                <span className="text-nowrap">วันที่</span>
                {convertDateThai(
                  companyDetail?.internStudent[0]?.internDetail?.start_date,
                  true
                )}{" "}
                ถึง วันที่
                {convertDateThai(
                  companyDetail?.internStudent[0]?.internDetail?.end_date,
                  true
                )}{" "}
                จำนวน {converToThaiNumber(companyDetail?.internStudent?.length)}{" "}
                คน ดังนี้
              </div>

              <div className="col-12">
                {companyDetail?.internStudent &&
                  companyDetail?.internStudent.length &&
                  companyDetail?.internStudent.map((std, index) => {
                    const levelRaw =
                      +std?.internDetail?.school_yrs?.slice(-2) +
                      1 -
                      +std?.internDetail?.st_id.slice(0, 2);
                    const level = levelRaw <= 4 ? levelRaw : 4;

                    return (
                      <div
                        className="row"
                        style={{ margin: "0 auto" }}
                        key={index}
                      >
                        <div className="col-6" style={{ textIndent: "50px" }}>
                          {converToThaiNumber(index + 1)}) {std.name}
                        </div>
                        <div className="col-6">
                          นิสิตปีที่ {converToThaiNumber(level)} สาขาวิชา{" "}
                          {matchOptions(optionsBranch, std?.b_id)}
                        </div>
                        <input
                          className="d-none"
                          name="groupStd[]"
                          value={std.id}
                        />
                      </div>
                    );
                  })}
              </div>
              <div className="col-12 mt-4" style={{ textIndent: "75px" }}>
                จึงเรียนมาเพื่อโปรดพิจารณาให้ความอนุเคราะห์ จักขอบคุณยิ่ง
              </div>
              <div className="col-12 mt-4 d-flex justify-content-end">
                <div className="text-center" style={{ paddingRight: "39mm" }}>
                  <div>ขอแสดงความนับถือ</div>
                  <div style={{ height: "15mm" }} />
                  <div>
                    <div>
                      <input
                        style={{ width: "300px" }}
                        name="president"
                        type="text"
                        className="input-form border-0 text-center"
                        defaultValue={"(ผู้ช่วยศาสตราจารย์ ดร.ณยศ คุรุกิจโกศล)"}
                      />
                    </div>
                    <div>
                      <input
                        style={{ width: "500px" }}
                        name="president_pos1"
                        type="text"
                        className="input-form border-0 text-center"
                        defaultValue={"คณบดีคณะวิศวกรรมศาสตร์"}
                      />
                    </div>
                    <div>
                      <input
                        style={{ width: "300px" }}
                        name="president_pos2"
                        type="text"
                        className="input-form border-0 text-center"
                        //defaultValue={"คณบดีคณะวิศวกรรมศาสตร์"}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-6">
                <div>สำนักงานคณบดี </div>
                <div>โทร. ๐ ๓๘๑๐ ๒๒๒๒ ต่อ ๓๓๑๕, ๓๓๒๔ </div>
                <div>ไปรษณีย์อิเล็กทรอนิกส์ co-op@eng.buu.ac.th</div>
              </div>
              <div className="col-6 d-flex align-items-end justify-content-end">
                {/* <Barcode
                  value="256500001"
                  width={1.5}
                  height={30}
                  fontSize={10}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <input
        type="text"
        className="d-none"
        name="idm_start_date"
        value={companyDetail?.internStudent[0]?.internDetail?.start_date}
      />
      <input
        type="text"
        className="d-none"
        name="idm_end_date"
        value={companyDetail?.internStudent[0]?.internDetail?.end_date}
      />
      <input
        type="text"
        className="d-none"
        name="cp_id"
        value={companyDetail?.id}
      />
      <input
        type="text"
        className="d-none"
        name="type_intern"
        value={companyDetail?.internStudent[0]?.internDetail?.type_internship}
      />
      <input
        type="text"
        className="d-none"
        name="date_create"
        value="2022-09-28 15:03:29"
      />
      <input type="text" className="d-none" name="user" value={profile?.name} />
    </form>
  );
};

export default FormReview;
